import { useEffect } from 'react';

import { GetPathOptions } from '@services/RouteService/paths';

import { useReactiveVar } from '@apollo/client';
import { redirectUnloggedUser } from '@boot/reactiveVariables';

export const useServiceRedirect = ({ params, path }: GetPathOptions) => {
    useEffect(() => {
        redirectUnloggedUser({ params, path });
    }, []);
};

export const useGetServiceRedirect = () => {
    const redirectData = useReactiveVar(redirectUnloggedUser);

    const isSurveysRedirect = !!redirectData.params?.surveyId;
    const isDisclosuresRedirect =
        !!redirectData.params?.disclosureUuid &&
        !redirectData.params?.submissionUuid;

    return {
        ...redirectData,
        isDisclosuresRedirect,
        isSurveysRedirect,
    };
};
